module.exports = __webpack_public_path__ + "static/media/010-Begruessen_ID_10.7e969a15.mp3";